import { defineMessages } from 'react-intl'

import { STORE_TABS } from 'app/utils/constants/status.constants'

export const seoDescriptionMessages = defineMessages({
  [STORE_TABS.products]: {
    defaultMessage:
      'Browse a wide selection of auto parts from {sellerName}. Filter by make, model, category, and find the right parts for your car.'
  },
  [STORE_TABS.reviews]: {
    defaultMessage:
      'Explore ratings and feedback {sellerName} earned from buyers and sellers. Discover how others rate their trust, reliability, and service.'
  }
})
